import React, { Component } from 'react';
import { DivisionTable } from './DivisionTable';
import { PlayoffPushTable } from './PlayoffPushTable';

export class Standings extends Component {

    constructor(props) {
    super(props);
        this.state = { nflStandings: [], loading: true, displayPlayoffPush: false,displayStandings: true  };
    }

    componentDidMount() {
        this.getStandings();
    }

    handlePlayoffPush = () => {
        console.log("Playoff Push Clicked");
    this.setState({ displayPlayoffPush : true });
     this.setState({ displayStandings : false }) ;
  };

  handleStandings = () => {
    this.setState({ displayStandings : true });
     this.setState({ displayPlayoffPush : false });
  };

   
    

    static renderStandings(standingsData,handlePlayoffPush,handleStandings,displayStandings) {
    return (
      <div>
        <div>
            <button className="btn btn-primary nflSubmitBtn" onClick={handleStandings} style={{ width: 100 }}>Standings</button>  <button className="btn btn-primary nflSubmitBtn"  onClick={handlePlayoffPush}>PlayoffPush</button>
        </div>
            {displayStandings && (
              <>
                <DivisionTable title="NFC WEST" divprefix="nfcwest" data={standingsData}/>
                <DivisionTable title="NFC EAST" divprefix="nfceast" data={standingsData}/>
                <DivisionTable title="NFC SOUTH" divprefix="nfcsouth" data={standingsData}/>
                <DivisionTable title="NFC NORTH" divprefix="nfcnorth" data={standingsData}/>
                <DivisionTable title="AFC WEST" divprefix="afcwest" data={standingsData}/>
                <DivisionTable title="AFC EAST" divprefix="afceast" data={standingsData}/>
                <DivisionTable title="AFC SOUTH" divprefix="afcsouth" data={standingsData}/>
                <DivisionTable title="AFC NORTH" divprefix="afcnorth" data={standingsData}/>
              </>
            )}
        </div>
    );
    }

     static renderPlayoffPush(standingsData) {
        return (
        <div>
                <h1>NFL 2k26 PlayoffPush</h1>
                <PlayoffPushTable title="NFC" divprefix="nfc" data={standingsData}/>
                <PlayoffPushTable title="AFC" divprefix="afc" data={standingsData}/>
        </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : Standings.renderStandings(this.state.nflStandings,this.handlePlayoffPush,this.handleStandings,this.state.displayStandings);
        let renderPlayoffPush = this.state.displayPlayoffPush
            ? Standings.renderPlayoffPush(this.state.nflStandings)
            : <div></div>;

        return (
            <div>
                {contents}
                {renderPlayoffPush}
            </div>
        );
    }

    async getStandings() {
        const response = await fetch('nflstandings');
        const data = await response.json();
        this.setState({ nflStandings: data, loading: false });
    }
}
